<template>
  <div class="export-info-card">
    <v-card color="white" min-height="85" elevation="4">
      <v-row class="px-5 justify-center align-center no-flex" :class="{ 'text-center': xsOrsm }">
        <v-col class="id fw-600 body pr-0" cols="12" :xs="12" sm="3" :md="3">
          <div class="pr-1 fs-13 text-uppercase">EXP/{{ item.jobName }}/2020-21</div>
          <div class="body-subtitle fs-13">{{ item.jobDate }}</div>
        </v-col>
        <v-col class="body pl-0" cols="12" :xs="12" sm="5" :md="4">
          <div class="fs-13 text-uppercase">
            {{ item.exporterName }}
          </div>
          <div class="fs-13 body-subtitle">
            Invoice Name: {{ item.invoiceName }} - Containers: {{ item.noOfContainers }}
          </div>
          <div class="fs-13 body-subtitle">Scheme: {{ item.schemeAbbreviations }}</div>
        </v-col>
        <v-col
          cols="12"
          md="5"
          lg="5"
          class="action-icons text-right"
          :class="{ 'd-flex wrap justify-center': $vuetify.breakpoint.xs }"
        >
          <v-row class="justify-center align-center">
            <v-col xs="6" sm="6" md="4" lg="4">
              <v-btn
                color="info"
                @click="generateChecklist(item)"
                :loading="isCheckListButtonLoading"
                class="white--text font-weight-bold mx-2 mx-auto"
              >
                Checklist
                <v-icon small right>fas fa-file</v-icon>
              </v-btn>
            </v-col>
            <v-col xs="6" sm="6" md="4" lg="4">
              <v-btn
                color="button-primary"
                @click="generateFlatfile(item)"
                :loading="isFlatfileButtonLoading"
                class="white--text font-weight-bold mx-2"
              >
                Flat File
                <v-icon small right>fas fa-download</v-icon>
              </v-btn>
            </v-col>
            <!-- <v-btn class="mx-2" icon @click="$emit('export-info-card', { action: 'edit', data: item })"> -->
            <v-col xs="12" sm="12" md="4" lg="4" class="text-center">
              <v-btn class="mx-auto " :loading="isEditActionLoading" icon @click="editExportJobs(item)">
                <v-icon>far fa-edit</v-icon>
              </v-btn>
              <v-btn class="mx-auto" :loading="isDeleteActionLoading" icon @click="askForDeletingExportJob(item)">
                <v-icon color="error">far fa-trash-alt</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
// import Utils from "@/utils/Utils";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import * as AT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/actionTypes";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
export default {
  name: "ExportInfoCard",
  data() {
    return {
      loading: false,
      isDeleteActionLoading: false,
      isFlatfileButtonLoading: false,
      isCheckListButtonLoading: false,
      isEditActionLoading: false
    };
  },
  props: {
    item: {
      required: true,
      type: Object
    },
    bus: {
      type: Object,
      default: null
    }
  },
  mixins: [commonMethodsMixin],
  created() {
    this.bus.$on("export-job-delete-confirmation", data => {
      this.exportJobDeleteConfirmation(data.exportJobId);
    });
    this.bus.$on("export-job-delete-denial", data => {
      this.exportJobDeleteDenial(data.exportJobId);
    });
  },
  methods: {
    log() {
      const id = this.item && this.item.id;
      this.$router.push({ name: "dashboard.export.sbMain", params: { exportJobId: id } });
    },
    generateFlatfile(exportJob) {
      this.isFlatfileButtonLoading = true;
      this.$store
        .dispatch(AT.GENERATE_FLATFILE, { exportJobId: exportJob.id })
        .then(res => {
          if (res) {
            window.open(exportJob.url, true);
            return;
          }
        })
        .catch(err => {
          this.$emit("flatFile-Error", err);
        })
        .finally(() => {
          this.isFlatfileButtonLoading = false;
        });
    },

    exportJobDeleteDenial(exportJobId) {
      if (this.item && this.item.id === exportJobId) {
        this.isDeleteActionLoading = false;
      }
    },
    exportJobDeleteConfirmation(exportJobId) {
      if (this.item && this.item.id === exportJobId) {
        this.$store
          .dispatch(AT.DELETE_EXPORT_JOB, { exportJobId: exportJobId })
          .then(() => {
            this.$emit("delete-export-job-from-array", this.item);
          })
          .catch(err => {
            this.handleError(err);
          })
          .finally(() => {
            this.isDeleteActionLoading = false;
          });
      }
    },
    askForDeletingExportJob(exportJob) {
      this.isDeleteActionLoading = true;
      this.$emit("open-delete-confirmation-dialog", exportJob);
    },
    dashboardSearchActionHandler(searchedString) {
      console.log("search", searchedString);
    },
    editExportJobs(exportJob) {
      this.isEditActionLoading = true;
      this.$store
        //passing 1 temporarily to get exportjob id 1
        .dispatch(AT.EDIT_EXPORT_JOB, { exportJobId: exportJob.id })
        .then(res => {
          if (res) {
            this.$store.commit(MT.SET_EXPORT_JOB, { exportJob: res.job_data });
            this.$store.commit(MT.SET_EXPORT_JOB_ID, { id: res.id });
            this.$router.push({ name: "dashboard.export.sbMain", params: { exportJobId: res.id } });
            // this.exportJobData = res;
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isEditActionLoading = false;
        });
    }
  }
};
</script>
<style lang="scss">
@import "../../../styles/settings/index";

.export-info-card {
  .v-card {
    z-index: 4;
    border-radius: 11px;
    .row {
      min-height: inherit;
      .id {
        font-size: 18px;
      }
      .body {
        .body-title {
          font-size: 17px;
          font-weight: 600;
          color: #121212;
        }
        .body-subtitle {
          font-size: 15px;
          font-weight: 500;
          color: $export-subtitle;
        }
      }
      .date {
        font-size: 18px;
        color: #121212;
      }
    }
  }
}
</style>
